import React from 'react'
import Product from './Product';
import "./Mobiles.css"

function Mobiles() {
    return (
        <div className="home">
        <div className="home_container">
            <img className="mobileimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/IN-hq/2020/img/Certified_Refurbished/XCM_Manual_1296151_1514230_IN_in_renewed_mobiles_header_in_en_3592283_1500x300_en_IN.jpg"/>
             <div className="home_row">

                 <Product title='Xiaomi 11 Lite NE 5G (Jazz Blue 6GB RAM 128 GB Storage) ' price={26999}  image='https://m.media-amazon.com/images/I/71XmlboxNZL._SL1500_.jpg' rating={4} />
                 <Product title="OnePlus Nord CE 5G (Blue Void, 8GB RAM, 128GB Storage)"price={24999}  image='https://m.media-amazon.com/images/I/61iy2Ru9KdS._SL1500_.jpg' rating={4} />
                 <Product title="iQOO Z3 5G (Ace Black, 6GB RAM, 128GB Storage) "price={12999}  image='https://m.media-amazon.com/images/I/61uIgwiP90S._SL1200_.jpg' rating={4} />
                 <Product title="Redmi 9 Activ (Coral Green, 4GB RAM, 64GB Storage)"price={8499}  image='https://m.media-amazon.com/images/I/91kAtEXPIeL._SL1500_.jpg' rating={3} />
             </div>
             <div className="home_row">
                 <Product title='Samsung Galaxy S20 FE 5G (Cloud Navy, 8GB RAM, 128GB Storage) ' price={36990}  image='https://m.media-amazon.com/images/I/81vDZyJQ-4L._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy M32 5G (Sky Blue, 6GB RAM, 128GB Storage)"price={16999}  image='https://m.media-amazon.com/images/I/71os5DRhuSL._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy M21 2021 Edition (Charcoal black, 6GB RAM, 128GB Storage) "price={13999}  image='https://m.media-amazon.com/images/I/712+A5mH44L._SL1500_.jpg' rating={4} />
                 <Product title="Samsung Galaxy Note 20 Ultra 5G (Mystic Bronze, 12GB RAM, 256GB Storage)"price={84999}  image='https://m.media-amazon.com/images/I/71eVZFpYUvL._SL1500_.jpg' rating={5} />
             </div>
             <img className="mobileimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Wireless/MobileInsider/June/11th/06.jpg"/>
             <img className="mobileimg" src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/HCTP/IBG/BrowseIngresses/Smartphone_IBG_browse_ingress.jpg"/>
             


        </div>

        
    </div>
    )
}

export default Mobiles
